import React from 'react';
import { BlogPostTemplate } from '../components/Blog/BlogPostTemplate';
import blogData from '../data/blog/en/passive-aggressive-texts-guide.json';
import { BlogPostData } from '../types/blog';
export function BlogPostPassiveAggressiveTexts() {
  return <BlogPostTemplate content={blogData as BlogPostData} data-id="element-3858" />;
}